<template>
  <div @click.stop="fatClick">
    <el-form :label-width="labelWidth" :model="complaint" :rules="complaintRules" ref="ruleForm"
      v-if="activeName != 2 && activeName != 'third'">
      <el-form-item label="平台：" :required="otherRequired" prop="platformCode">
        <el-select placeholder="请选择" v-model="complaint.platformCode" size="small" clearable @change="getShopInfo">
          <el-option v-for="(item, i) in plateList" :key="i" :label="item.dictName" :value="item.dictCode"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="违规类型：" required prop="reportviolation" v-if="pdBmcid === '4581'">
        <el-select placeholder="请选择" v-model="complaint.reportviolation" size="small" clearable>
          <el-option v-for="(item, i) in typeViolation" :key="i" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="店铺名称：" :required="otherRequired" prop="shopname"
        v-if="activeName !== 'second' && activeName !== 'fourth'"
        onkeypress="javascript:if(event.keyCode == 32)event.returnValue = false;">
        <shopNameAuto ref="refShopname" v-model="complaint.shopname" :platformCode="complaint.platformCode"
          @selectShopname="selectShopname"></shopNameAuto>
        <ShopType style="margin-top: 8px;" :shoptype="complaint.shoptype" v-if="complaint.shoptype" />
      </el-form-item>
      <el-form-item label="违规链接：" :required="required" prop="reporturl"
        v-if="activeName !== 'second' && activeName !== 'fourth'">
        <div style="display: flex;" id="tramtion">
          <el-input placeholder="请输入" v-model="complaint.reporturl" size="small" clearable @blur="changeUrl"
            onkeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"></el-input>
          <div v-loading="loading" style="width: 32px;height: 32px;color: white;">
            1
          </div>
        </div>
      </el-form-item>

      <!-- 验证链接 -->
      <checkLink :labelWidth="labelWidth" :plateformValue="plateformValue" @checkLinks="checkLinks" ref="refcheckLink"
        @vertityLinkFlow="vertityLinkFlow" :ifUrlSku="true" v-if="activeName === 'second' && activeName !== 'fourth'"
        @haveRepeatUrl="haveRepeatUrl" @delFalseLink="delFalseLink" :needHttps="true"></checkLink>
      <el-form-item label="产品信息：" :required="otherRequired" prop="productinfoid"
        v-if="activeName !== 'second' && this.complaint.reporturl">
        <checkProduct :echoproduct_id="echoproduct_id" ref="checkProduct" v-model="productData"
          @setproduct="setproduct"></checkProduct>
        <div v-if="addprice || handprice">
          <span style="padding-right: 10px;">
            <span v-if="addprice" style="padding-right: 10px;">建议标价：{{ addprice }}</span>
            <span v-if="handprice">建议零售价：{{ handprice }}</span>
          </span>
        </div>
      </el-form-item>
      <el-form-item label="违规价格：" prop="availableprice"
        v-if="activeName !== 'second' && activeName !== 'fourth' && pdBmcid == '753' || pdBmcid == '4603'">
        <div style="display: flex;" id="tramtion">
          <el-input placeholder="请输入" v-model="complaint.availableprice" size="small" clearable
            onkeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"></el-input>
        </div>

      </el-form-item>
      <el-form-item label="举证材料：" :required="required" prop="reportpic" v-if="activeName !== 'fourth'">
        <uploadAdjunct @attachUrls="attachUrls" class="screenshot" title="选择文件" ref="upload" :imgList="reportpic">
        </uploadAdjunct>
      </el-form-item>
      <el-form-item label="补充说明：" v-if="activeName !== 'fourth'">
        <el-input type="textarea" placeholder="请输入备注说明，请保持在200字以内。" v-model="complaint.explain"
          resize="none"></el-input>
      </el-form-item>
      <el-form-item label="表格：" :required="required" v-if="activeName == 'fourth'">
        <el-upload ref="newupload" class="upload-demo" drag
          :action="'hcm/hcmReport/readExcelFileReport?platform=' + complaint.platformCode" :auto-upload="false" multiple
          :before-upload="beforeUpload" accept=".xls,.xlsx" :on-success="confirmUpload">
          <i class="el-icon-upload" style="color: #BDA571;"></i>
          <div class="el-upload__text" style="font-size: 16px;color: #333333;">将文件拖到此处，或<em>点击上传</em>
            <br>
            <span style="font-size: 14px;color: #d4d4d4;">
              支持扩展名：.xls .xlsx
            </span>
          </div>
        </el-upload>
        <el-button size="small" @click="exportExcel">下载模板</el-button>
      </el-form-item>
      <el-form-item v-if="activeName !== 'fourth'">
        <el-button type="confire_btn" @click="submitForm('ruleForm')" size="small"
          :disabled="cancelBtnShow">确认</el-button>
        <el-button @click="cancelClear" size="small" type="cancel_blue">取消</el-button>
      </el-form-item>
      <el-form-item v-else>
        <el-button type="confire_btn" @click="BulkImport()" size="small" :loading="bulLoading">确 定</el-button>
        <el-button @click="BulkImportShowf()" style="margin-left: 10px;" size="small" type="cancel_blue">取 消</el-button>
      </el-form-item>
    </el-form>

    <el-card v-if="activeName != 1 && activeName != 'first' && activeName != 'second' && activeName !== 'fourth'"
      style="border-radius: 5px;border: 1px solid #E4E7ED;width: 500px;">
      <div style="width: 100%;">
        <i class="el-icon-connection" style="font-size: 36px;float: left;"></i>
        <div style="font-size: 18px;font-weight: bold;float: left;margin-left: 10px;margin-top: 5px;">
          匿名举报链接
        </div>
      </div>
      <div style="clear: both;margin-bottom: 30px;">
        <div style="width: 250px;float: left;">
          <el-link :underline="false" :href='"https://brmwx.olonger.com/#/newExternalApproval?" + brmBmcid'
            target="_blank" style="font-weight: bold;">
            <div style="width: 250px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
              https://brmwx.olonger.com/#/newExternalApproval?{{ brmBmcid }}
            </div>
          </el-link>
        </div>
        <div style="float: left;margin-left: 25px;">
          <el-button type="confire_btn" @click="cancel" size="mini">复制链接</el-button>
          <el-button @click="twoMa = true" size="mini">生成二维码</el-button>
        </div>
      </div>
      <!-- <img :src='"data:image/png;base64," + getReportQRcodeURL' alt style="width: 100px;height: 100px;" /> -->
    </el-card>

    <el-dialog title="生成二维码" :visible.sync="twoMa" width="400px">
      <div style="width: 100%;text-align: center;margin-top: 39px;color: #606266;font-size: 14px;">
        扫描下方二维码，可通过手机端进行举报
      </div>
      <div style="width: 214px;height: 214px;border: 1px solid #DAE8FF;text-align: center;margin: 25px auto;">
        <img :src='"data:image/png;base64," + getReportQRcodeURL' alt
          style="width: 187px;height: 187px;padding: 13px;position: relative;" />
        <img src="../../../assets/img/topleft.png"
          style="width: 22px;height: 22px;position: absolute;top: 141px;left: 88px;">
        <img src="../../../assets/img/topright.png"
          style="width: 22px;height: 22px;position: absolute;top: 141px;right: 88px;">
        <img src="../../../assets/img/bottomleft.png"
          style="width: 22px;height: 22px;position: absolute;top: 344px;left: 88px;">
        <img src="../../../assets/img/bottomright.png"
          style="width: 22px;height: 22px;position: absolute;top: 344px;right: 88px;">
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="confire_btn" size="small" @click="twoMa = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="repetitionShow" width="20%" style="margin-top: 10%;">
      <div style="display: flex;width: 100%;justify-content:center;">
        <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
        <div>
          <div style="font-size: 16px;">当前举报链接已被举报，且在店铺整改时间</div>
          <div style="font-size: 14px;">范围内，暂不支持重复举报</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="confire_btn" size="small" @click="repetitionShow = false">我知道了</el-button>
      </span>
    </el-dialog>

    <el-dialog title="导入失败列表" :visible.sync="BulkImportShow" width="800px">
      <el-table :data="responseData" style="width: 100%">
        <el-table-column prop="platformCode" label="平台">
          <template slot-scope="scope">
            <div>
              {{ scope.row.platformCode | platformChinese }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="shopname" label="店铺名称">
        </el-table-column>
        <el-table-column prop="point" label="扣分/加分">
        </el-table-column>
        <el-table-column prop="err_info" label="错误说明">
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button type="confire_btn" size="small" @click="BulkImportShow = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import { getLoginType } from "@/libs/until";
import uploadAdjunct from "@/views/NotificationPublic/uploadAdjunct2";
import checkLink from "components/checkLink/checkLink";
import {
  handleProductUrl,
  getUrlParam,
  getItemId,
  linktoplatform,
} from "@/libs";
import checkProduct from "components/checkProduct/index";
import { fetchGet, fetchPost } from "@/libs/reqCommon";
import ShopType from "@/components/shopType";
import shopNameAuto from "./shopNameAuto";
import aes from "@/libs/aes";
export default {
  name: "outInform",
  props: {
    activeName: {
      type: String,
    },
  },
  data: function () {
    return {
      typeViolation: [{
        label: '运营力违规-产品展示违规',
        value: '运营力违规-产品展示违规',
      }, {
        label: '运营力违规-产品标题违规',
        value: '运营力违规-产品标题违规',
      }, {
        label: '运营力违规-店铺评分违规',
        value: '运营力违规-店铺评分违规',
      }, {
        label: '高端力违规-偏离sku违规',
        value: '高端力违规-偏离sku违规',
      }, {
        label: '高端力违规-连续违规',
        value: '高端力违规-连续违规',
      }, {
        label: '商品力违规-在售宝贝个数违规',
        value: '商品力违规-在售宝贝个数违规',
      }, {
        label: '商品力违规-下架宝贝个数违规',
        value: '商品力违规-下架宝贝个数违规',
      }, {
        label: '商品力违规-连续违规',
        value: '商品力违规-连续违规',
      }],
      responseData: [],
      loading: false,
      addprice: "",
      handprice: "",
      plateformValue: "",
      repetitionShow: false,
      labelWidth: "130px",
      echoproduct_id: "",
      complaint: {
        productinfoid: "",
        shopname: "",
        platformCode: "",
        reporturl: "",
        explain: "",
        productinfo: "",
        reportpic: "",
        shoptype: "",
        wangwang: "",
        availableprice: '',
      },
      productData: [],
      required: true,
      otherRequired: false,
      logintype: getLoginType(),
      complaintRules: {
        reporturl: [{ required: true, message: "请选择违规链接" }],
        reportpic: [{ required: true, message: "请上传举证材料" }],
      },
      batchLink: false,
      verifyResult: [],
      getShopListGet: [],
      cancelBtnShow: false,
      reportpic: [],
      isAmendBtn: false, //是否是修改信息
      ifCheckAgain: false,
      batchVerityResult: [],
      userData: JSON.parse(localStorage.getItem('userData')),
      getReportQRcodeURL: '',
      brmBmcid: localStorage.getItem('bmcKefuid'),
      pdBmcid: '',
      twoMa: false,
      bulLoading: false,
      BulkImportShow: false,
    };
  },
  filters: {
    objToAr: aes.objToArr
  },
  components: {
    uploadAdjunct,
    checkLink,
    checkProduct,
    ShopType,
    shopNameAuto,
  },
  created() {
    this.pdBmcid = localStorage.getItem('bmcKefuid')
    if (localStorage.getItem('bmcKefuid')) {
      this.brmBmcid = aes.encrypt(localStorage.getItem('bmcKefuid'), "hcmabcdefghijklm")
    } else {
      this.brmBmcid = aes.encrypt(this.userData.bmcid, "hcmabcdefghijklm")
    }

    this.selectbmcCampaigntype()
    this.getReportQRcode()
    this.reqPlateList();
    // this.GetListBMC();
    this.otherRequired = true;
    if (this.otherRequired) {
      this.complaintRules.platformCode = [
        { required: true, message: "请选择平台" },
      ];
      this.complaintRules.shopname = [
        { required: true, message: "请输入店铺名称" },
      ];
      this.complaintRules.productinfoid = [
        { required: true, message: "请选择产品信息" },
      ];
    }
    if (this.$route.query.reporturl) this.echoReport();
  },
  computed: {
    ...mapGetters([
      "plateList",
      "newgetShopProducts",
      "changeOutInform",
      "getShopList",
    ]),
    ...mapState({
      linkVerifyResult: (state) => state.creditScore.linkVerifyResult,
      tbpassword: (state) => state.creditScore.tbpassword,
      dimShopName: (state) => state.creditScore.dimShopName,
      productIdprice: (state) => state.creditScore.productIdprice,
    }),
  },
  methods: {
    exportExcel() {
      if (this.pdBmcid === '4581') {
        window.open('http://preview.olonger.com/system/%E8%BF%9D%E8%A7%84%E4%B8%BE%E6%8A%A5%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx');
      } else {
        window.open('https://hawksights.obs.cn-east-2.myhuaweicloud.com/system/%E8%BF%9D%E8%A7%84%E4%B8%BE%E6%8A%A5%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx');
      }
    },
    // 确定导入
    BulkImport() {
      if (!this.complaint.platformCode) {
        this.$message.error('请先选择平台')
        return
      }
      this.bulLoading = true
      this.$refs.newupload.submit();
    },
    // 取消导入
    BulkImportShowf() {
      this.bulLoading = false;
      this.$refs.newupload.clearFiles();
    },
    beforeUpload(file) {
      let Xls = file.name
      if (Xls.search("xls") != -1 || Xls.search("xlsx") != -1) {
        return file
      } else {
        this.$message.error('上传文件只能是 xls/xlsx 格式!')
        return false
      }
    },
    confirmUpload(response) {
      this.bulLoading = false;
      if (response.status != '10000') {
        this.$message.error(response.message);
      } else {
        this.responseData = []
        if (response.data && response.data.length > 0) {
          this.$message({
            message: response.message,
            type: 'warning'
          });
          this.responseData = response.data
          this.BulkImportShow = true
        } else {
          this.$message({
            message: response.message,
            type: 'success'
          });

        }
      }
    },
    // 更具状态来判断是否可以上传举证材料
    selectbmcCampaigntype() {
      fetch({
        url: "hcm/cus/selectbmcSetting",
        method: "get",
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          if (res.data.reportRequiredField) {
            this.complaintRules.reportpic[0].required = true
            this.required = true
          } else {
            this.complaintRules.reportpic[0].required = false
            this.required = false
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 生成二维码
    getReportQRcode() {
      fetch({
        url: "hcm/cus/getReportQRcode",
        method: "get",
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        this.getReportQRcodeURL = res
        // if(res.status == '10000'){
        //
        //
        // } else {
        //   this.$message.error(res.message);
        // }
      })
    },
    // 复制链接
    cancel() {
      let oInput = document.createElement('input');
      oInput.value = 'https://brmwx.olonger.com/#/newExternalApproval?' + this.brmBmcid;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: '复制成功',
        type: 'success'
      });
      oInput.remove()
    },
    fatClick() {
      this.$refs.checkProduct.allQx()
    },
    ...mapActions([
      "reqPlateList",
      "getVerifyReportLink",
      // "GetListBMC",
      // "getTBPassword",
      "getInfoByProductIds",
      "getfinShopByName",
    ]),
    ...mapMutations(["getVerifyResult"]),
    haveRepeatUrl() {
      //重复链接提示
      this.$set(this, "cancelBtnShow", true);
    },
    async getShopInfo(val) {
      if (this.complaint.shopname) {
        let res = await this.getfinShopByName({
          shopname: this.complaint.shopname,
          platformCode: val,
        });
        if (this.dimShopName.length > 0)
          this.complaint.shoptype = this.dimShopName[0].shoptype;
      }
      this.plateformValue = val;
    },
    echoReport() {
      //其他页面跳转，回显到页面
      let {
        platform_code,
        shopname,
        productinfoid,
        reportpic,
        explain,
        reporturl,
        shopid,
        shoptype,
        productinfo,
        availablecheckprice,
        itemtitle,
        checkprice,
        availableprice,
        price,
        wangwang,
        itemid,
        itemlink,
      } = this.$route.query;
      //页面上的信息
      this.query = this.$route.query;
      this.complaint.platformCode = platform_code;
      this.complaint.shopname = shopname;
      this.echoproduct_id = productinfoid;
      this.reportpic = Array.isArray(reportpic)
        ? reportpic
        : reportpic.split(",");
      this.complaint.explain = explain;
      this.complaint.reporturl = reporturl;
      this.complaint.shopid = shopid;
      this.complaint.productinfoid = productinfoid;
      this.complaint.reportpic = String(reportpic);
      this.isAmendBtn = true;
      this.complaint.shoptype = shoptype;
      this.complaint.productinfo = productinfo;
      //其他信息
      let otherData = [
        {
          itemtitle,
          availablecheckprice,
          checkprice,
          availableprice,
          price,
          wangwang,
          itemid,
          itemlink,
        },
      ];
      this.getVerifyResult(otherData);
      this.$nextTick(() => {
        this.$refs.refShopname.echoShopName(shopname);
      });
    },
    delFalseLink() {
      //批量验证链接删除链接
      let linkVerifyResult = this.linkVerifyResult;
      let link = this.$refs.refcheckLink.tureLink;
      let ifcheckLink = this.$refs.refcheckLink.ifcheckLink;
      let reason = [];
      //判断能不能进行下一步
      this.complaint.reporturl = link;
      // this.cancelBtnShow =ifcheckLink.indexOf('false')!==-1?true:false
    },
    selectShopname(item) {
      if (item) {
        this.complaint.shopid = item.shopid;
        this.complaint.shoptype = item.shoptype;
        this.complaint.shopname = item.shopname;
        this.complaint.wangwang = item.wangwang;

        if (item.shopname) this.complaint.platformCode = item.platformCode;
      } else {
        this.complaint.shopid = "";
        this.complaint.shopname = "";
        this.complaint.shoptype = "";
        this.complaint.wangwang = "";
      }
      this.$forceUpdate();
    },
    submitForm(formName) {
      console.log(this.complaint.availableprice, 'this.complaint.availableprice')
      console.log(this.linkVerifyResult[0], 'this.linkVerifyResult[0]')
      this.$refs[formName].validate((valid) => {
        console.log(this.brmBmcid, 'this.brmBmcid')
        let bmcid = localStorage.getItem('bmcKefuid');
        if (bmcid == '753') {
          if (this.complaint.availableprice && this.linkVerifyResult[0] && this.linkVerifyResult[0].availablecheckprice || this.linkVerifyResult[0].availablecheckprice == 0) {
            if (this.complaint.availableprice > this.linkVerifyResult[0].availablecheckprice || this.complaint.availableprice == this.linkVerifyResult[0].availablecheckprice) {
              this.$message.error("违规价格需小于建议零售价");
              return
            }
          }
        }
        if (valid) {
          this.cancelBtnShow = true;
          if (this.activeName === "first" || this.activeName == "1") {
            if (this.isAmendBtn) {
              //快速重新举报
              this.fastInsertReport();
            } else {
              this.saveReport();
            }
          } else {
            //批量举报
            this.saveReportBatch();
          }
          this.$refs.checkProduct.allClear()
        } else {
          this.cancelBtnShow = false;
          return false;
        }
      });
    },
    checkLinks(link) {
      this.complaint.reporturl = String(link);
      this.verifyReportLink();
    },
    vertityLinkFlow() {
      if (!this.complaint.platformCode) {
        this.$message.error("请选择平台");
        return false;
      }
      this.cancelBtnShow = false;
      this.$refs.refcheckLink.handleCheckTrue();
    },
    attachUrls(val) {
      let fileArr = [];
      for (let item of val) {
        let fileitem =
          "https://hawksights.obs.cn-east-2.myhuaweicloud.com/" + item.url;
        fileArr.push(fileitem);
      }
      //获取上传附件
      this.$set(this.complaint, "reportpic", String(fileArr));
    },
    dealShopProducts() {
      for (let item of this.newgetShopProducts) {
        if (item.children) {
          this.moreVerityData(item.children);
        }
      }
    },
    moreVerityData(data) {
      for (let items of data) {
        let arr = items.id.split(",");
        items.id = arr[0];
        if (items.children) {
          this.moreVerityData(items.children);
        }
      }
    },
    changeUrl() {
      if (this.complaint.reporturl.indexOf('https://v.douyin.com') != -1) {
        this.getLongUrlByShortUrl(this.complaint.reporturl)
      } else {
        this.verifyReportLink()
      }
    },
    async verifyReportLink() {
      //验证链接
      this.loading = true;
      let platform
      if (this.activeName == "first" || this.activeName == "1") {
        this.complaint.reporturl = this.complaint.reporturl.replace(
          "http://",
          "https://"
        );
        platform = linktoplatform(this.complaint.reporturl);
        console.log(platform, 'platformplatformplatform')
        this.complaint.platformCode = platform;
        if (platform) {
          let getUrl = handleProductUrl(this.complaint.reporturl);
          this.complaint.reporturl = getUrl;
        }
      }
      if (platform == 'XHS' || platform == 'DY') {
        this.loading = false;
      } else {
        if (!getItemId(this.complaint.reporturl)) {
          this.ifVerityLink = false;
          return;
        }
      }
      this.ifVerityLink = true;
      if (this.complaint.platformCode != 'HM') {
        return await this.goonReportUrl();
      } else {
        this.loading = false;
      }

    },
    // 抖音链接转换
    getLongUrlByShortUrl() {
      let params = {
        url: this.complaint.reporturl
      }
      fetch({
        url: "hcm/wechat/getLongUrlByShortUrl",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          console.log(data)
          this.complaint.reporturl = data
          this.verifyReportLink()
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      })
    },
    //判断重复弹窗是否显示
    verityReatUrl() {
      if (this.linkVerifyResult.length > 0) {
        let result = this.linkVerifyResult[0];
        let checkShoptype = result.shoptype
          ? result.shoptype
          : this.complaint.shoptype;
        if (result.reason == 1) {
          //重复提示
          this.$set(this, "cancelBtnShow", true);
          this.$set(this, "repetitionShow", true);
          return false;
        } else {
          return true;
        }
      }
    },
    async goonReportUrl() {
      //验证链接
      if (!this.complaint.reporturl) {
        return false;
      }
      let url
      // =
      // this.activeName == "first"
      //   ? [this.complaint.reporturl]
      //   : this.complaint.reporturl.split(",");
      if (this.activeName == "first" || this.activeName == "1") {
        url = [this.complaint.reporturl] + '+first'
      } else {
        url = this.complaint.reporturl.split(",") + '+second';
      }
      await this.getVerifyReportLink(url, this.activeName);
      if (this.activeName == "first" || this.activeName == "1") {

        //单条
        let result = this.linkVerifyResult[0];
        let ifCheckAgain = true; //判断是否验证过链接
        let checkShoptype = result.shoptype
          ? result.shoptype
          : this.complaint.shoptype;
        if (this.verityReatUrl()) {
          this.cancelBtnShow = false;
          if (result.checkprice) {
            this.addprice = result.checkprice
          }
          if (result.availablecheckprice) {
            this.handprice = result.availablecheckprice
          }
          console.log(this.productData)
          if (result.productinfoid) {
            this.echoproduct_id = result.productinfoid;
            this.$refs.checkProduct.getProductinfo(result);
            this.complaint.productinfoid = result.productinfoid;
            this.complaint.productinfo =
              this.productData.length > 0 ? this.productData[1][1] : [];
          }
          // this.setproduct()
          let { platformCode, shopname, shopid, shoptype, wangwang } = result;
          if (platformCode) this.complaint.platformCode = platformCode;
          if (shopname) {
            this.complaint.shopid = shopid;
            this.complaint.shoptype = shoptype;
            this.complaint.shopname = String(shopname);
            this.complaint.wangwang = String(wangwang);
            this.$refs.refShopname.echoShopName(String(shopname));
          }
        }
      } else {
        //批量
        this.$refs.refcheckLink.reportLinkCheck(this.linkVerifyResult);
        this.complaint.reporturl = this.$refs.refcheckLink.tureLink; //保存链接
        this.$refs.refcheckLink.cancheckDisabled();
        this.cancelBtnShow = false; //可以点击确认
        this.batchLink = true;
      }
      this.loading = false;
      return this.linkVerifyResult;
    },
    setproduct(val) {
      console.log(val)
      this.productData = val;
      if (val.length > 0) {
        this.complaint.productinfo = val[1][1];
        this.complaint.productinfoid = val[0] + "," + val[1][0];
      }
      this.changeGetProductInfo();
    },
    async changeGetProductInfo() {

      await this.getInfoByProductIds({
        id: this.complaint.productinfoid,
        platform: this.complaint.platformCode,
      });
      if (this.productIdprice.data && this.productIdprice.data) {
        this.handprice = this.productIdprice.data[0].handprice
        this.addprice = this.productIdprice.data[0].addprice
      }
    },
    async fastInsertReport() {
      //重新举报
      let result;
      let data = {
        ...this.linkVerifyResult[0],
        ...this.complaint,
      };
      fetchPost("hcm/hcmReport/fastInsertReport", data)
        .then((res) => {
          if (res.status == "10000") {
            this.$message({ type: "success", message: "成功" });
            this.cancelClear();
          }
          this.cancelBtnShow = false;
        })
        .catch(() => {
          this.cancelBtnShow = false;
        });
    },
    async saveReport() {
      //单条链接保存
      if (!this.ifVerityLink) {
        cosnole.log(this.ifVerityLink, '请输入正确的链接')
        this.$message.error("请输入正确的链接");
        return;
      }
      if (!this.complaint.shoptype) delete this.complaint.shoptype;
      let other = this.linkVerifyResult[0];
      delete other.shoptype;
      delete other.shopid;
      delete other.shopname;
      let data = {
        ...this.linkVerifyResult[0],
        ...this.complaint,
      };
      // delete data.reason;
      console.log(this.linkVerifyResult[0]);
      console.log(this.complaint);
      console.log(data);
      if (data && data.productinfo.length == 1) {
        data.productinfo = this.linkVerifyResult[0].productinfo
      }
      if (data.reason == 3) {
        data.reporturl = this.linkVerifyResult[0].itemlink
      }
      console.log(data, 'datdatda')
      fetchPost("hcm/hcmReport/saveReport", data)
        .then((res) => {
          this.cancelBtnShow = false;
          if (res.status == "10000") {
            this.$message({ type: "success", message: "成功" });
            this.cancelClear();
            this.$refs.refShopname.clearData();
            this.handprice = ''
            this.addprice = ''
          } else {
            this.cancelBtnShow = false;
            this.$message.error(res.message);
          }
        })
        .catch(() => {
          this.cancelBtnShow = false;
        });
    },
    saveReportBatch() {
      if (!this.batchLink) {
        this.$message.error("请先验证链接");
        return false;
      }
      if (!this.complaint.reporturl) {
        return false;
      }
      let url = this.complaint.reporturl;
      console.log(url)
      if (url.length === 0) {
        this.$message.error('请添加链接');
        return
      }
      this.$refs.refcheckLink.checkRedLink();
      let data = [];
      url.map((link, index) => {
        delete this.complaint.reporturl;
        delete this.complaint.shopname;
        delete this.complaint.productinfoid;
        delete this.complaint.productinfo;
        let obj = Object.assign({});
        let verityObj = Object.assign({});
        obj = {
          ...this.complaint,
          reporturl: link,
        };
        verityObj = this.linkVerifyResult[index];
        delete verityObj.reason;
        let formParams = Object.assign({}, obj, verityObj);
        data.push(formParams);
      });
      fetch({
        url: "hcm/hcmReport/saveReportBatch",
        method: "post",
        data: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
        },
        noFormat: false,
        responseType: "json",
      })
        .then((res) => {
          this.cancelBtnShow = false;
          if (res.status == "10000") {
            this.$message.success("成功");
            this.cancelClear();
          } else {
            this.cancelBtnShow = false;
            this.$message.error(res.message);
          }
        })
        .catch(() => {
          this.cancelBtnShow = false;
        });
    },
    cancelClear() {
      this.cancelBtnShow = false;
      //清空
      let data = {
        productinfoid: "",
        productinfo: "",
        explain: "",
        shoptype: "",
        shopname: "",
        platformCode: "",
        reporturl: "",
      };
      this.reportpic = [];
      this.echoproduct_id = "";
      this.$set(this, "complaint", data);
      this.$refs["ruleForm"].resetFields();
      this.$refs.upload.clearUrls();
      if (this.activeName === "second") {
        this.$set(this, "plateformValue", "");
        this.$forceUpdate();
        this.$refs.refcheckLink.clearData();
      } else {
        this.$refs.checkProduct.product_id = [];
        this.$refs.refShopname.echoShopName("");
      }
      this.$forceUpdate();
    },
  },
};
</script>
<style lang="scss">
#tramtion {
  .el-loading-spinner .circular {
    height: 24px;
    width: 24px;
  }

  .el-loading-spinner {
    margin-top: 8px;
    margin-left: 8px;
    top: 1%;
  }
}
</style>
